import React from "react";
import { useLocation } from "react-router";
import { observer } from "mobx-react-lite";

import {
  IonAvatar,
  IonButton,
  IonItem,
  IonLabel,
  IonIcon,
  IonSkeletonText,
  IonText,
} from "@ionic/react";

import { personCircle, peopleCircle } from "ionicons/icons";

import * as Models from "../../../models";
import AnimatedImg from "../../../components/AnimatedImg";

interface GroupsListItemProps {
  group: Models.Group;
  onSelectItem: (item: Models.Group) => void;
}

const GroupsListItem: React.FC<GroupsListItemProps> = observer(
  ({ group, onSelectItem }) => {
    const location = useLocation();

    if (group && group.loaded) {
      return (
        <IonItem
          //color={location.pathname == `/groups/${group.id}` ? "light" : ""}
          //routerLink={`/groups/${group.id}`}
          detail={false}
          onClick={() => onSelectItem(group)}
          button
        >
          <IonAvatar
            style={{ height: "50px", width: "50px" }}
            className="ion-margin-end border-radius-0"
            color="medium"
          >
            {group?.avatar
              ? <AnimatedImg alt="" src={group?.avatar ?? undefined} />
              : undefined
            }
          </IonAvatar>
          <IonLabel>
            <h2>{group.name}</h2>
          </IonLabel>
        </IonItem>
      );
    }

    return (
      <IonItem>
        <IonAvatar
          className="border-radius-0"
          slot="start"
          style={{
            height: "50px",
            width: "50px",
          }}
        >
          <IonIcon
            icon={peopleCircle}
            color="medium"
            style={{ fontSize: "50px" }}
          ></IonIcon>
        </IonAvatar>
        <IonLabel>
          <h2>
            <IonSkeletonText animated style={{ width: "70%" }} slot="start" />
          </h2>
        </IonLabel>
      </IonItem>
    );
  }
);

export default GroupsListItem;
